<template>
    <div>
        <div class="image-cropper">
            <input type="file" ref="fileInput" accept="image/*" @change="handleFileSelect" class="file-input" />
            <button @click="triggerFileSelect">选择图片</button>

            <!-- 裁剪区域 -->
            <div class="cropper-container" v-if="imageUrl">
                <img ref="cropperImg" :src="imageUrl" @load="initCropper" class="cropper-img" />
            </div>

            <!-- 控制滑块区域 -->
            <div class="controls-sliders" v-if="imageUrl">
                <!-- 旋转角度控制滑块 -->
                <div class="slider-item">
                    <label>旋转角度: {{ rotationDegree }}°</label>
                    <input type="range" v-model="rotationDegree" min="-180" max="180" step="1" class="range-slider"
                        @input="handleRotationChange">
                </div>
                <!-- 尺寸控制滑块 -->
                <div class="slider-item">
                    <label>裁剪尺寸: {{ cropSize }}px × {{ cropSize }}px</label>
                    <input type="range" v-model="cropSize" min="100" max="200" step="10" class="range-slider">
                </div>
            </div>

            <!-- 预览裁剪后的图片（透明背景） -->
            <div v-if="croppedBase64" class="preview">
                <p>裁剪结果（透明背景预览）：</p>
                <div class="transparent-bg">
                    <img :src="croppedBase64" alt="裁剪后的图片" class="result-img">
                </div>
            </div>

            <!-- 控制按钮 -->
            <div class="controls" v-if="imageUrl">
                <button @click="rotate(-90)">向左旋转 90°</button>
                <button @click="rotate(90)">向右旋转 90°</button>
                <button @click="reset">重置</button>
                <button @click="cropAndGetBase64">预览</button>
            </div>
        </div>
    </div>
</template>
<script>
// 确保导入正确
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';


export default {
    name: "",
    components: {
        
    },
    data() {
        return {
            //印章裁剪
            imageUrl: '',
            cropperInstance: null,
            croppedBase64: '',
            cropSize: 150, // 默认裁剪尺寸
            rotationDegree: 0, // 旋转角度，默认0度
            lastRotation: 0, // 记录上一次旋转角度，用于计算相对旋转
        }
    },
    created() { },
    mounted() {

    },
    methods: {
        //裁剪 处理文件选择
        triggerFileSelect() {
            this.$refs.fileInput.click();
        },

        handleFileSelect(e) {
            const file = e.target.files[0];
            if (!file) return;

            if (!file.type.startsWith('image/')) {
                alert('请选择图片文件');
                return;
            }

            this.imageUrl = URL.createObjectURL(file);
            this.$refs.fileInput.value = '';
            this.croppedBase64 = '';
            this.rotationDegree = 0;
            this.lastRotation = 0; // 重置旋转记录
        },

        initCropper() {
            if (this.cropperInstance) {
                this.cropperInstance.destroy();
            }

            if (this.$refs.cropperImg) {
                this.cropperInstance = new Cropper(this.$refs.cropperImg, {
                    aspectRatio: 1,
                    viewMode: 1,
                    background: false,
                    autoCropArea: 0.8
                });
            }
        },
        // 修复：使用相对旋转替代resetTransform
        handleRotationChange() {
            if (this.cropperInstance) {
                // 计算与上一次旋转的差值（相对旋转角度）
                const delta = this.rotationDegree - this.lastRotation;
                // 应用相对旋转
                this.cropperInstance.rotate(delta);
                // 更新上一次旋转记录
                this.lastRotation = this.rotationDegree;
            }
        },

        // 按钮旋转控制
        rotate(degree) {
            if (this.cropperInstance) {
                this.cropperInstance.rotate(degree);
                // 更新旋转角度值
                this.rotationDegree = (this.rotationDegree + degree) % 360;
                this.lastRotation = this.rotationDegree; // 同步记录值

                // 保持角度在-180到180之间
                if (this.rotationDegree > 180) {
                    this.rotationDegree -= 360;
                    this.lastRotation = this.rotationDegree;
                } else if (this.rotationDegree < -180) {
                    this.rotationDegree += 360;
                    this.lastRotation = this.rotationDegree;
                }
            }
        },

        // 重置功能
        reset() {
            if (this.cropperInstance) {
                this.cropperInstance.reset();
                this.rotationDegree = 0;
                this.lastRotation = 0; // 重置旋转记录
            }
        },

        // 预览
        cropAndGetBase64() {
            if (!this.cropperInstance) return;

            const tempCanvas = document.createElement('canvas');
            const ctx = tempCanvas.getContext('2d');

            tempCanvas.width = this.cropSize;
            tempCanvas.height = this.cropSize;

            const croppedCanvas = this.cropperInstance.getCroppedCanvas({
                width: this.cropSize,
                height: this.cropSize,
                imageSmoothingQuality: 'high'
            });

            ctx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
            ctx.drawImage(croppedCanvas, 0, 0, this.cropSize, this.cropSize);

            this.croppedBase64 = tempCanvas.toDataURL('image/png');
        },
        
    }
}
</script>
<style scoped>
.file-input {
  display: none;
}

.cropper-container {
  margin: 20px 0;
  width: 100%;
  max-width: 400px;
  height: 200px;
  border: 1px dashed #ccc;
}
.cropper-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.controls-sliders {
  margin: 15px 0;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 4px;
}
.slider-item {
  margin-bottom: 15px;
}
.controls {
  margin: 20px 0;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.slider-item:last-child {
  margin-bottom: 0;
}
.range-slider {
  width: 100%;
  margin: 10px 0;
}
.preview {
  margin: 20px 0;
}
.image-cropper button {
  padding: 8px 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.image-cropper button:hover {
  background-color: #409eff;
}
/* 透明背景预览区（用网格背景示意透明效果） */
.transparent-bg {
  display: inline-block;
  padding: 20px;
  background-image:
    linear-gradient(45deg, #eee 25%, transparent 25%),
    linear-gradient(-45deg, #eee 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #eee 75%),
    linear-gradient(-45deg, transparent 75%, #eee 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}
.result-img {
  max-width: 100%;
  border: 1px solid #ddd;
}
</style>